import objectHash from "object-hash";
import { getAggregationBasedFields } from "./fieldsHelper.ts";
import { getAllFilters } from "./getAllConditions.ts";
import type { ConditionField, ReportField, TabularColumn } from "../../../../../api/types/svTypes.ts";

export function getColumns(fields: ReportField[], columns: TabularColumn[]): ResponseColumn[] | undefined {
  if (fields.length === 0 || columns.length === 0) {
    return undefined;
  }
  return fields
    .map((field) => {
      const column = columns.find((c) => c.guid === field.config.guid);
      if (!column) {
        return undefined;
      }

      return {
        id: field.config.guid,
        title: column.title ?? field.config.customLabel ?? field.meta.caption,
        failedToLoad: column.failedToLoad,
      };
    })
    .filter((c): c is ResponseColumn => c !== undefined);
}

export function getConditionsHash(conditions: ConditionField[], fields: ReportField[]) {
  const measures = getAggregationBasedFields(fields);
  return objectHash(getAllFilters(conditions, measures));
}

export type ResponseColumn = {
  id: string;
  title: string;
  failedToLoad: boolean;
};
